import { Box, Icon } from '@palmetto/palmetto-components';

export const FlagCount = ({ count }: { count: number }) => (
  <Box background="danger" direction="row" fontSize="sm" padding="sm" gap="2xs" radius="sm" alignItems="center">
    <Icon name="flag" color="body-primary" />
    <Box color="body-primary">{`${count} ${count > 1 ? 'flags' : 'flag'}`}</Box>
  </Box>
);
